import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const KEY = "dh_desk_theme";
const DeskThemeContext = createContext(null);

function defaultFor(role) {
  return role === "broker" || role === "admin" || role === "seller" ? "dark" : "light";
}

function readTheme(role) {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "{}");
    if (raw[role] === "dark" || raw[role] === "light") return raw[role];
  } catch {
    /* ignore */
  }
  return defaultFor(role);
}

export function DeskThemeProvider({ role, children }) {
  const [deskTheme, setTheme] = useState(() => readTheme(role));

  useEffect(() => {
    setTheme(readTheme(role));
  }, [role]);

  const setDeskTheme = useCallback(
    (next) => {
      if (next !== "dark" && next !== "light") return;
      setTheme(next);
      try {
        const raw = JSON.parse(localStorage.getItem(KEY) || "{}");
        raw[role] = next;
        localStorage.setItem(KEY, JSON.stringify(raw));
      } catch {
        /* private mode */
      }
    },
    [role]
  );

  const value = useMemo(() => ({ deskTheme, setDeskTheme, role }), [deskTheme, setDeskTheme, role]);
  return <DeskThemeContext.Provider value={value}>{children}</DeskThemeContext.Provider>;
}

export function useDeskTheme() {
  return useContext(DeskThemeContext);
}
